import { useNavigate } from 'react-router-dom'
import { useAuthStore } from './data/stores/auth.store'
import { useEffect } from 'react'
import { APP_ROUTES } from '../constants/routes'
import AuthActionsLayout from './layout/auth-actions-layout'
import { parse } from 'tldts'

export default function AuthWrapper() {
  const { isAuthenticated, redirectUri, session, resetInitSession } = useAuthStore()
  const nav = useNavigate()

  // useEffect(() => {
  //   // Cleanup function to reset init session on mount
  //   resetInitSession()
  // }, [resetInitSession])

  useEffect(() => {
    if (isAuthenticated) {
      if (redirectUri) {
        try {
          // Build redirect URL with token query param
          const url = new URL(redirectUri)
          const encodedToken = session?.idToken ? btoa(session.idToken) : ''

          const isDifferentDomain = parse(redirectUri).domain !== parse(window.location.origin).domain

          if (encodedToken && isDifferentDomain) {
            url.searchParams.set('token', encodedToken)
          }

          // Clear history and redirect
          resetInitSession()
          window.location.replace(url.toString())
        } catch (error) {
          console.error('Failed to redirect with token:', error)
          window.location.replace(redirectUri)
        }
      } else {
        resetInitSession()
        nav(APP_ROUTES.Account, { replace: true })
      }
    }
  }, [isAuthenticated, nav, redirectUri, resetInitSession, session])

  return <AuthActionsLayout />
}
